import React, { useState, useEffect, useReducer, useRef } from "react";

import { isSameDay, parseISO, format } from "date-fns";
import openSocket from "../../services/socket-io";
import clsx from "clsx";
import { green } from "@material-ui/core/colors";
import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  makeStyles,
  LinearProgress
} from "@material-ui/core";
import {
  // AccessTime,
  Block,
  Edit,
  Done,
  DoneAll,
  ExpandMore,
  GetApp
} from "@material-ui/icons";
import TranslateIcon from '@material-ui/icons/Translate';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Fab from '@material-ui/core/Fab';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Player from "./reactPlayer";
import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import ModalImageSticker from "../ModalImageSticker";
import MessageOptionsMenu from "../MessageOptionsMenu";
//import whatsBackground from "../../assets/wa-background.png";
import Badge from '@material-ui/core/Badge';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import api from "../../services/api";
import toastError from "../../errors/toastError";
import Typography from '@material-ui/core/Typography';
//import Twemoji from 'react-twemoji';


const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    userSelect: "text",
  },

  messagesList: {
    backgroundImage: theme.backgroundImage,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "90px",
    },
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    textAlign: "justify",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    backgroundColor: theme.messageLeft.backgroundColor,
    color: theme.messageLeft.color,
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 10,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.quotedContainerLeft.backgroundColor,
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 400,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    wordBreak: "break-word",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageRight: {

    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    textAlign: "justify",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    backgroundColor: "#dcf8c6",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 10,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: "#cfe9ba",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 400,
    height: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: theme.messageContactName.color,
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemInternal: {
    fontStyle: "italic",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
    color: "#1414b8",
    backgroundColor: "#cfe9f9",
    borderRadius: "7.5px",
  },

  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 0,
    right: 5,
    color: "#999",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
  },
  scrollToBottom: {
    position: 'fixed',
    margin: '0px',
    top: 'auto',
    right: '10px',
    bottom: '150px',
    left: 'auto'
  }
}));

const reducer = (state, action) => {

  if (action.type === "LOAD_MESSAGES") {

    const messages = action.payload;

    const newMessages = [];

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        newMessages.push(message);
      }
    });

    return [...newMessages, ...state];
  }

  if (action.type === "ADD_MESSAGE") {

    const newMessage = action.payload;
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
    } else {
      state.push(newMessage);
    }

    return [...state];
  }

  if (action.type === "UPDATE_MESSAGE") {

    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    if (messageIndex !== -1) {
      state[messageIndex] = messageToUpdate;
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const MessagesList = ({ ticketId, isGroup }) => {
  const classes = useStyles();

  const [messagesList, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastMessageRef = useRef();
  const [finalPageNumber, setFinalPageNumber] = useState(true);

  const [selectedMessage, setSelectedMessage] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const currentTicketId = useRef(ticketId);
  const [modalOpen, setModalOpen] = useState({ urlVideo: '', open: false });
  const [messagePendent, setMessagePendent] = useState(0);

  const [isTranscribing, setIsTranscribing] = useState(null);
  const [transcriptionError, setTranscriptionError] = useState({});


  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);

    currentTicketId.current = ticketId;
  }, [ticketId]);

  useEffect(() => {

    let isMounted = true;
    setLoading(true);

    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        try {

          const { data } = await api.get("/messages/" + ticketId, {
            params: { pageNumber },
          });

          //console.log('data', data);

          if (isMounted) {
            if (currentTicketId.current === ticketId) {
              dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
              setHasMore(data.hasMore);
              setLoading(false);
            }

            if (pageNumber === 1 && data.messages.length > 1) {
              scrollToBottom();
            }
          }
        } catch (err) {
          setLoading(false);
          toastError(err);
        }

        return [];
      };
      fetchMessages();
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
      isMounted = false;
    };
  }, [pageNumber, ticketId]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("connect", () => socket.emit("joinChatBox", ticketId));

    socket.on("appMessage", (data) => {

      if (data.action === "create") {
        dispatch({ type: "ADD_MESSAGE", payload: data.message });

        scrollToBottom(data.message);
      }

      if (data.action === "update") {
        dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [ticketId]);

  const loadMore = () => {

    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const scrollToBottom = (msn = '') => {

    const { scrollTop, scrollHeight, clientHeight } = document.getElementById("messagesList");
    //console.log('clientHeight', clientHeight, scrollHeight, scrollTop, (scrollHeight - scrollTop))

    const size = (scrollHeight - scrollTop) - 600
    //console.log('scrollTop, clientHeight, size', scrollTop, clientHeight, size)

    if (scrollTop === 0 || clientHeight > size || msn?.fromMe) {
      if (lastMessageRef.current) {
        lastMessageRef.current.scrollIntoView({});
      }

      setMessagePendent(0);
    } else {
      console.log('message pendent')
      setMessagePendent((prev) => prev + 1)
    }

  };

  const downScroll = () => {

    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }

    setMessagePendent(0);

  };


  const handleScroll = (e) => {
    if (!hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    //console.log(scrollTop, scrollHeight, clientHeight)
    //console.log('Scroll: ', (scrollHeight - scrollTop), clientHeight);

    const size = scrollHeight - scrollTop - 50;
    if (clientHeight > size) {
      setMessagePendent(0);
    }

    if (scrollTop === 0) {
      document.getElementById("messagesList").scrollTop = 1;
    }

    if (loading) {
      return;
    }

    if (scrollTop < 50) {

      if (finalPageNumber) {
        setFinalPageNumber(false);
        loadMore();
      }

    } else {
      setFinalPageNumber(true);
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const handleTranscribeFile = async (message) => {
    // 1. Inicia o estado de carregamento
    setIsTranscribing(message.id);
    setTranscriptionError(prev => ({ ...prev, [message.id]: false }));

    try {
      // 2. Chama a rota do Backend
      // Não precisamos atribuir o resultado a uma variável 'data' 
      // porque o texto virá automaticamente via Socket.io no 'message.body'
      await api.get(`/messages/transcribe/${message.id}`);

    } catch (err) {
      console.error("Erro ao transcrever via Backend:", err);
      setTranscriptionError(prev => ({ ...prev, [message.id]: true }));
      
      if (err.response?.status === 429) {
        alert("Limite de transcrições atingido. Aguarde um minuto e tente novamente.");
      }
    } finally {
      // 3. Finaliza o estado de carregamento
      setIsTranscribing(null);
    }
  };

  const checkMessageMedia = (message) => {

    if (message.mediaType === "location" && message.body.split('|').length >= 2) {
      let locationParts = message.body.split('|')
      let imageLocation = locationParts[0]
      let linkLocation = locationParts[1]

      let descriptionLocation = null

      if (locationParts.length > 2)
        descriptionLocation = message.body.split('|')[2]

      return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
    }
    else if (message.mediaType === "vcard") {
      //console.log("vcard")
      //console.log(message)
      let array = message.body.split("\n");
      let obj = [];
      let contact = "";
      for (let index = 0; index < array.length; index++) {
        const v = array[index];
        let values = v.split(":");
        for (let ind = 0; ind < values.length; ind++) {
          if (values[ind].indexOf("+") !== -1) {
            obj.push({ number: values[ind] });
          }
          if (values[ind].indexOf("FN") !== -1) {
            contact = values[ind + 1];
          }
        }
      }
      if (typeof obj[0] === 'undefined') {
        console.log('LOG VcardPreview', obj[0]);
        return;
      }
      return <VcardPreview contact={contact} numbers={obj[0].number} />
    }
    /*else if (message.mediaType === "multi_vcard") {
      console.log("multi_vcard")
      console.log(message)
      
      if(message.body !== null && message.body !== "") {
        let newBody = JSON.parse(message.body)
        return (
          <>
            {
            newBody.map(v => (
              <VcardPreview contact={v.name} numbers={v.number} />
            ))
            }
          </>
        )
      } else return (<></>)
    }*/
    else if (message.mediaType === "sticker") {

      return <ModalImageSticker imageUrl={message.mediaUrl} />;

    }
    else if (message.mediaType === "image") {

      return <ModalImageCors imageUrl={message.mediaUrl} />;

    } // ... dentro do checkMessageMedia, na parte do audio:
    else if (message.mediaType === "audio") {
      // Verificamos se já existe texto no corpo da mensagem (que não seja apenas o nome do arquivo)
      const isAlreadyTranscribed = message.body && message.body.includes("Transcrição:");

      return (
        <div style={{ display: "flex", flexDirection: "column", minWidth: "250px" }}>
          <audio id={`audio-${message.id}`} controls>
            <source src={message.mediaUrl} type="audio/ogg"></source>
          </audio>
          
          {/* 1. O botão só aparece se NÃO houver transcrição no corpo da mensagem */}
          {!isAlreadyTranscribed && (
            <Button
              size="small"
              color="primary"
              variant="outlined"
              startIcon={isTranscribing === message.id ? <CircularProgress size={16} /> : <TranslateIcon />}
              onClick={() => handleTranscribeFile(message)}
              style={{ marginTop: "5px", fontSize: "10px", textTransform: "none" }}
              disabled={isTranscribing === message.id}
            >
              {isTranscribing === message.id ? "IA Processando..." : "Converter em Texto (IA)"}
            </Button>
          )}

          {/* 2. Status de carregamento animado */}
          {isTranscribing === message.id && (
            <div style={{ marginTop: "8px", width: "100%" }}>
              <Typography variant="caption" style={{ color: "#00bfa5", fontWeight: "bold" }}>
                IA convertendo áudio em texto...
              </Typography>
              <LinearProgress 
                variant="indeterminate" 
                style={{ height: 4, borderRadius: 2, marginTop: 4 }}
              />
            </div>
          )}

          {/* REPORTE DE ERRO: Mantemos apenas o aviso de falha, se houver */}
          {transcriptionError[message.id] && (
            <Typography style={{ color: "#f44336", fontSize: "11px", marginTop: "5px", fontWeight: "bold" }}>
              Falha na conversão.
            </Typography>
          )}

          {/* NOTA: Removi o bloco "Exibição do Texto Transcrito" daqui, 
            pois o próprio WhaTicket já vai renderizar o message.body 
            abaixo desse componente automaticamente.
          */}
        </div>
      );
    } else if (message.mediaType === "video") {

      return (

        <div>
          <video
            className={classes.messageMedia}
            src={message.mediaUrl}
            controls
          />
          <Fab
            key={message.id}
            onClick={() => {
              setModalOpen({ urlVideo: message.mediaUrl, open: true })
            }}>
            <PlayCircleOutlineIcon
              size="large"
              color="primary"
            />
          </Fab>
        </div>
      );

    } else {
      return (
        <>
          <div className={classes.downloadMedia}>
            <Button
              startIcon={<GetApp />}
              color="primary"
              variant="outlined"
              target="_blank"
              href={message.mediaUrl}
            >
              Download
            </Button>
          </div>
          <Divider />
        </>
      );
    }
  };

  const renderMessageAck = (message) => {
    if (message.ack === 0) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 1) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 2) {
      return <DoneAll fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 3 || message.ack === 4) {
      return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />;
    }
  };

  const renderDailyTimestamps = (message, index) => {
    if (index === 0) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
          </div>
        </span>
      );
    }
    if (index < messagesList.length - 1) {
      let messageDay = parseISO(messagesList[index].createdAt);
      let previousMessageDay = parseISO(messagesList[index - 1].createdAt);

      if (!isSameDay(messageDay, previousMessageDay)) {
        return (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
            </div>
          </span>
        );
      }
    }
    if (index === messagesList.length - 1) {
      return (
        <div
          key={`ref-${message.createdAt}`}
          ref={lastMessageRef}
          style={{ float: "left", clear: "both" }}
        />
      );
    }
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;

      if (messageUser !== previousMessageUser) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {

    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        ></span>
        <div className={classes.quotedMsg} style={{ img: { with: '10px' } }}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.contact?.name}
            </span>
          )}

          {(message.quotedMsg.mediaUrl || message.quotedMsg.mediaType === "location" || message.quotedMsg.mediaType === "vcard"
            //|| message.mediaType === "multi_vcard" 
          ) && checkMessageMedia(message.quotedMsg)}
          {message.quotedMsg?.body}
        </div>
      </div>
    );
  };

  const getStringColor = (string, saturation = 80, lightness = 30) => {


    return toColor(string);

    /*
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }


    let hashFinal = Math.abs(hash) % 360;

    if (hashFinal < 40) {
      hashFinal += 40;
    } else if (hashFinal > 240) {
      hashFinal -= 100;
    }

    //console.log(`hash, string : ${hash}, ${string}`);
    //console.log(`hsl(${hashFinal}, ${saturation}%, ${lightness}%)`);

    

    return `hsl(${hashFinal}, ${saturation}%, ${lightness}%)`;
    */
  };

  const toColor = (str) => {

    var colors = ["#77c277", "#87CEEB", "#D2691E", "#008B8B", "#4682B4", "#259b24", "#8bc34a", "#afb42b", "#556b2f", "#DEB887", "#228b22"]

    var hash = 0;
    if (!str || (str && str.length === 0)) return hash;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }
    hash = ((hash % colors.length) + colors.length) % colors.length;
    return colors[hash];
  }

  const renderMessages = () => {

    if (messagesList.length > 0) {

      const viewMessagesList = messagesList.map((message, index) => {

        if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div className={classes.messageLeft}>
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {isGroup && (
                  <span className={classes.messageContactName} style={{ color: getStringColor(message.contact?.number) }}>
                    {message.contact?.name}
                  </span>
                )}
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)
                }
                {
                  (message.mediaType === "call_log") && (
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17">
                        <path fill="#df3333" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path>
                      </svg> <span>Chamada de voz/vídeo</span>
                    </div>
                  )
                }

                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                  })}>

                  {message.isDeleted && (
                    <Block
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.isEdit && (
                    <Edit
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.isForwarded && (
                    <>
                      <ArrowForwardIcon
                        color="disabled"
                        fontSize="small"
                        className={classes.deletedIcon}
                      />
                      <span style={{ fontSize: 11, fontStyle: 'italic', color: 'blueviolet' }}>Msg Encaminhada  </span>
                    </>
                  )}

                  {message.quotedMsg && renderQuotedMessage(message)}
                  {/*<Twemoji options={{ className: 'twemoji' }}>*/}
                  <MarkdownWrapper>
                    {message.body}
                  </MarkdownWrapper>


                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div className={classes.messageRight}>
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                    [classes.textContentItemInternal]: message.isInternal && !message.isDeleted,
                  })}
                >
                  {message.isDeleted && (
                    <Block
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.isEdit && (
                    <Edit
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.isForwarded && (
                    <>
                      <ArrowForwardIcon
                        color="disabled"
                        fontSize="small"
                        className={classes.deletedIcon}
                      />
                      <span style={{ fontSize: 11, fontStyle: 'italic', color: 'blueviolet' }}>Msg Encaminhada  </span>
                    </>
                  )}
                  {message.isInternal && (
                    <Typography variant="inherit" color="primary">  Mensagem Interna <br /></Typography>
                  )}


                  {message.quotedMsg && renderQuotedMessage(message)}
                  {/*<Twemoji options={{ className: 'twemoji' }}>*/}
                  <MarkdownWrapper>
                    {message.body}
                  </MarkdownWrapper>


                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                    {renderMessageAck(message)}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        }
      });
      return viewMessagesList;
    } else {
      return <div>Say hello to your new contact!</div>;
    }
  };

  return (
    <div className={classes.messagesListWrapper}>
      {selectedMessage && (<MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
      />)}
      <div
        id="messagesList"
        className={classes.messagesList}
        onScroll={handleScroll}
      >
        {messagesList.length > 0 ? renderMessages() : []}

        {messagePendent > 0 && (<Badge
          badgeContent={messagePendent}
          color="secondary"
          overlap="rectangular"
          className={classes.scrollToBottom}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}>
          <Fab size="small"
            aria-label="add"
            onClick={() => downScroll()}>
            <ExpandMoreIcon
              size="small"
            />
          </Fab>
        </Badge>)}

      </div>
      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}
      {
        modalOpen.open && (
          <Player modalOpen={modalOpen} />
        )
      }
    </div>
  );
};

export default MessagesList;